import {
  BASE_QUERY,
  COMMON_QUERY_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  DEFAULT_SECTION_TOP_COUNT,
  ruleNewsPlus
} from './shared/configs';

enum SECTION_ENUM {
  RELATED_OPINION = 'Related Opinion'
}

const MAIN = {
  ...BASE_QUERY,
  query: {
    ...BASE_QUERY.query,
    or: [{ terms: { key: 'SectionType', value: ['The Future of Everything'] } }],
    not: [...BASE_QUERY.query.not, { terms: { key: 'AvailabilityFlags', value: ['WSJNOSF'] } }, ruleNewsPlus]
  }
};

const RELATED_OPINION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_RELATED_OPINION_QUERY_RULES_CONFIG.and ?? []),
      {
        codes_with_significance: {
          key: 'djething',
          significance: ['significant'],
          value: ['tech', 'tech/ai', 'tech/personal-tech', 'tech/biotech']
        }
      }
    ],
    or: [],
    not: []
  }
};

const SECTION_TOP = {
  ...MAIN,
  ...DEFAULT_SECTION_TOP_COUNT
};

const TOP_FIVE_STORIES = { ...MAIN, count: 5 };

const MORE_LIST = { ...MAIN };

export { SECTION_TOP, TOP_FIVE_STORIES, MORE_LIST, RELATED_OPINION, SECTION_ENUM };
